module.exports = __webpack_public_path__ + "static/img/05.3748b61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/05.jpg
// module id = YCKn
// module chunks = 0